import { css } from "@emotion/css";
import { Chip, RadioButtonNew, RadioGroupNew } from "@octopusdeploy/design-system-components";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { CompliancePolicyVersionResource, PolicyResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { PolicyBanner } from "~/areas/platformHub/policies/PolicyBanner";
interface PolicyActivationStatusDialogProps {
    policy: PolicyResource;
    version: string;
    activationStatus: PolicyActivationStatus;
    setActivationStatus: (activationStatus: PolicyActivationStatus) => void;
    currentVersion?: CompliancePolicyVersionResource;
}
export function PolicyActivationStatusDialog({ policy, version, activationStatus, setActivationStatus, currentVersion }: PolicyActivationStatusDialogProps) {
    const versionNumber = <Chip backgroundColor={themeTokens.color.badge.background.info} label={version} labelColor={themeTokens.color.badge.text.primary} noMargin={true}/>;
    const versions = (<div>
            {currentVersion ? (<span className={styles.versionContainer}>
                    <span>{currentVersion.Version}</span>
                    <span>→</span>
                    <Chip backgroundColor={themeTokens.color.badge.background.info} label={version} labelColor={themeTokens.color.badge.text.primary} noMargin={true}/>
                </span>) : (<span className={styles.versionContainer}>{version}</span>)}
            <div>A policy can only have one active version. By changing the version it will replace the version status immediately.</div>
        </div>);
    return (<div className={styles.dialogContainer}>
            <PolicyBanner heading={policy.Name} subHeading={versions} accessories={""}/>
            <div>
                <RadioGroupNew value={activationStatus} onChange={(status) => setActivationStatus(status)} label="">
                    <RadioButtonNew name="Active" value="Active" label="Active"/>
                    <RadioButtonNew name="Inactive" value="Inactive" label="Inactive"/>
                </RadioGroupNew>
            </div>
        </div>);
}
export type PolicyActivationStatus = "Active" | "Inactive";
const styles = {
    dialogContainer: css({
        display: "flex",
        flexDirection: "column",
        gap: space[32],
    }),
    name: css({
        font: text.body.bold.medium,
    }),
    versionContainer: css({
        display: "flex",
        gap: space[6],
        alignItems: "center",
        font: text.body.regular.small,
    }),
};
